/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Nunito Sans. Deliberately the old fontsource package: newer @fontsource releases ship the
// redesigned (wider) 2023 version of the font, which changes line wrapping across the site.
require('fontsource-nunito-sans/latin.css')

require('./src/styles/scss/app.scss')
